import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {FeedbackMediaProps} from "../../types/feedback-media-modal.types";
import {defaultFeedbackMediaProps} from "../../configs/feedback-media-modal-config";
import {ModalsService} from "../../../../../services/modals.service";
import {MatMiniFabButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-feedback-media-video',
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatIcon
  ],
  templateUrl: './feedback-media-video.component.html',
  styleUrl: './feedback-media-video.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackMediaVideoComponent {
  feedbackMediaProps = input<FeedbackMediaProps>(defaultFeedbackMediaProps);

  private modalsService: ModalsService = inject(ModalsService);

  public async handleOpenVideo() {
    await this.modalsService.openPreviewFileHlsModal(this.feedbackMediaProps().url);
  }
}
